import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Checkbox ,Tooltip } from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./DeactivatePrintedValidationsCheckboxStyles";

const DeactivatePrintedValidationsCheckbox = ({ checked, onChange }) => {
  const classes = useStyles();
  const [internalChecked, setInternalChecked] = useState(!!checked);

  useEffect(() => {
    setInternalChecked(!!checked);
  }, [checked]);

  const handleChange = (e) => {
    const newChecked = e && e.target ? e.target.checked : !internalChecked;
    setInternalChecked(newChecked);
    if (onChange) {
      onChange({ target: { checked: newChecked } });
    }
  };

  return (
    <Tooltip 
    title="Check this box to deactivate any printed validations tied to this validation account." 
    arrow placement="center" 
    >
    <FormControlLabel
      className={clsx("account-users-checkbox", classes.printedValidationsCheckbox)}
      control={
        <Checkbox
          checked={internalChecked}
          onChange={handleChange}
          color="primary"
        />
      }
      label="Deactivate unused printed validations"
    />
    </Tooltip>
  );
};

DeactivatePrintedValidationsCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

DeactivatePrintedValidationsCheckbox.defaultProps = {
  checked: false,
  onChange: () => {},
};

export default DeactivatePrintedValidationsCheckbox;
